let anrede = "Sehr geehrte Damen und Herren,";
let gruß = "Mit freundlichen Grüßen";
let signatur = "Vertriebsteam Sorten und Edelmetalle";
let kontakt = "(Tel.: 0911 2359 470; se-vertrieb@bayernlb.de)"

export default {
  STATUS: {
    SUCCESSFUL: "SUCCESSFUL",
    NO_SUCCESS: "NO_SUCCESS",
    OK_WITH_WARNING: "OK_WITH_WARNING",
    DELTA: "DELTA",
    HOSTERROR: "HOST_ERROR",
    ERROR: "ERROR"
  },
  ERROR: {
    92902: "Der Auftrag ist bereits storniert",
    92903: "Der Auftrag ist nicht mehr stornierbar",
    92904: "Es sind keine Auftragsdaten vorhanden",
    91011: "Die Order zum Auftrag konnte nicht ermittelt werden",
    91404: "Die Liste der Produkte konnte nicht geladen werden."
  },
  ERRORNUMMER: {
    TLS_VALIDIERUNG: "92500",
    TLS_LOGIN_VERSUCHE: "92404",
    ORDER_VALIDIERUNG: "92501",
    HOST_TIME_OUT: "92502",
    SENDE_AN_HOST_FEHLER: "92503",
    PDF_GENERIERUNG: "92504",
    MAILVERSAND: "92505",
    KONTODECKUNG: "92506",
    BANKAPI_INTERNAL_SERVER_ERROR: "92507",
    BANKAPI_FORBIDDEN: "92508",
    BANKAPI_GENERAL_ERROR: "92509",
    KATALOG_FEHLER: "91404",
    TAN_REJECTED: "92510",
    BANKAPI_KUNDE_NICHT_BERECHTIGT: "92511"
  },
  ERRORTITEL: {
    NO_SUCCESS_MITARBEITER: "Fehler bei der Auftragsverarbeitung",
    NO_SUCCESS_KUNDEN: "Fehler bei der Auftragsverarbeitung",
    TIMEOUT_MITARBEITER: "Fehler bei der Auftragsverarbeitung",
    TIMEOUT_KUNDEN: "Probleme bei der Auftragsverarbeitung",
    HOST_VALIDIERUNG_MITARBEITER: "Fehler bei der Auftragsverarbeitung",
    HOST_VALIDIERUNG_KUNDEN: "Fehler bei der Auftragsverarbeitung",
    PDF_GENERIERUNG_MITARBEITER: "Fehler bei der Erstellung der Auftragsbestätigung",
    PDF_GENERIERUNG_KUNDEN: "Fehler bei der Erstellung der Auftragsbestätigung",
    MAILVERSAND_MITARBEITER: "Versand der Auftragsbestätigung nicht möglich",
    MAILVERSAND_KUNDEN: "Versand der Auftragsbestätigung nicht möglich",
    UNBEKANNT: "Es ist ein Fehler aufgetreten.",
  },
  DELTA_STATUS: {
    "E0003": "WARN"
  },
  DELTA_ERROR: {
    E0003: "Fehler bei der Überprüfung des Warenkorbs. Die Daten wurden neu berechnet.",
    SUMME: "Die Überprüfung des Warenkorbs ist fehlgeschlagen. Bitte überprüfen Sie den Warenkorb und versuchen Sie es erneut.",
  },
  ERRORMESSAGE: {
    NO_SUCCESS_MITARBEITER: [
      anrede,
      `bei der Ausführung Ihrer Order ist ein Fehler aufgetreten. Der Auftrag konnte daher nicht ausgeführt werden. Bitte versuchen Sie es erneut. Sollte der Fehler weiterhin bestehen, wenden Sie sich bitte an die Ansprechpartner der BayernLB ${kontakt}.`,
      gruß,
      signatur
    ],
    NO_SUCCESS_KUNDEN: [
      anrede,
      "bei der Ausführung Ihrer Order ist ein Fehler aufgetreten. Der Auftrag konnte daher nicht ausgeführt werden. Bitte versuchen Sie es erneut. Sollte der Fehler weiterhin bestehen, wenden Sie sich bitte an Ihre Bank.",
      gruß,
      signatur
    ],
    TIMEOUT_MITARBEITER: [
      anrede,
      `bei der Ausführung der Order ist ein technisches Problem aufgetreten. Bitte wenden Sie sich an die Ansprechpartner der BayernLB ${kontakt}, um zu klären, ob der Auftrag dennoch ausgeführt werden konnte oder neu erfasst werden muss.`,
      "Speziell bei Ankäufen ist zudem die Auftragsbestätigung (bzw. Auftragsnummer) als Begleit-Dokument für die an die BayernLB zu versendente Ware zwingend erforderlich und von der BayernLB anzufordern.",
      gruß,
      signatur
    ],
    TIMEOUT_KUNDEN: [
      anrede,
      "bei der Ausführung Ihrer Order ist ein technisches Problem aufgetreten. Bitte wenden Sie sich an Ihre Bank, um zu klären, ob der Auftrag dennoch ausgeführt werden konnte oder neu erfasst werden muss.",
      gruß,
      signatur
    ],
    HOST_VALIDIERUNG_MITARBEITER: [
      anrede,
      `bei der Ausführung Ihrer Order ist ein Fehler aufgetreten. Der Auftrag konnte daher nicht ausgeführt werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut. Sollte der Fehler weiterhin bestehen, wenden Sie sich bitte an die Ansprechpartner der BayernLB ${kontakt}.`,
      gruß,
      signatur
    ],
    HOST_VALIDIERUNG_KUNDEN: [
      anrede,
      "bei der Ausführung Ihrer Order ist ein Fehler aufgetreten. Der Auftrag konnte daher nicht ausgeführt werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut. Sollte der Fehler weiterhin bestehen, wenden Sie sich bitte an Ihre Bank.",
      gruß,
      signatur
    ],
    PDF_GENERIERUNG_MITARBEITER: [
      anrede,
      "bei der Erstellung der Auftragsbestätigung für Ihre Order ist ein Fehler aufgetreten. Der Auftrag konnte dennoch auf technischem Wege übermittelt werden.",
      `Bei Ankäufen ist die Auftragsbestätigung (bzw. Auftragsnummer) als Begleit-Dokument für die an die BayernLB zu versendente Ware zwingend erforderlich und von der BayernLB anzufordern. Bitte wenden Sie sich hierfür an die Ansprechpartner der BayernLB ${kontakt}.`,
      gruß,
      signatur
    ],
    PDF_GENERIERUNG_KUNDEN: [
      anrede,
      "bei der Erstellung der Auftragsbestätigung für Ihre Order ist ein Fehler aufgetreten. Der Auftrag konnte dennoch ausgeführt werden.",
      gruß,
      signatur
    ],
    MAILVERSAND_MITARBEITER: [
      anrede,
      "beim Versand der Auftragsbestätigung für Ihre Order ist ein Fehler aufgetreten.",
      "Sollte der Kunde eine schriftliche Auftragsbestätigung benötigen, laden Sie diese bitte an dieser Stelle herunter oder drucken Sie aus.",
      gruß,
      signatur
    ],
    MAILVERSAND_KUNDEN: [
      anrede,
      "beim Versand der Auftragsbestätigung für Ihre Order ist ein Fehler aufgetreten.",
      "Sollten Sie eine schriftliche Auftragsbestätigung benötigen, laden Sie sich diese bitte an dieser Stelle herunter und drucken sie sich aus.",
      gruß,
      signatur
    ],
    TAN_ERROR_RESPONSE: [
      anrede,
      "bei Ihrer TAN-Authentifizierung ist ein Fehler aufgetreten.",
      "Bitten wenden Sie sich an Ihre Sparkasse.",
      gruß,
      signatur
    ],
    TAN_ORDER_PROCESS_ERROR_RESPONSE: [
      anrede,
      "bei der Auftragsverarbeitung Ihrer Bestellung ist ein Problem aufgetreten (Fehlercode {ERROR_CODE}).",
      "Bitte wenden Sie sich an Ihre Sparkasse, bevor Sie erneut bestellen. Gegebenenfalls konnte der Auftrag dennoch ausgeführt werden.",
      gruß,
      signatur
    ],

    KONTODECKUNG_KUNDE: [
      anrede,
      "das Guthaben auf dem ausgewählten Konto reicht für die Bestellung nicht aus. Bitte sorgen Sie zunächst für ausreichend Deckung oder verringern den Bestellwert.",
      "Bitte wenden Sie sich an Ihre Sparkasse.",
      gruß,
      signatur
    ],

    NICHT_BERECHTIGT_KUNDE: [
      anrede,
      "bei der Auftragsverarbeitung Ihrer Bestellung ist ein Problem aufgetreten.",
      "Das von Ihnen gewählte Konto ist für diese Auftragsart nicht vorgesehen. Erlaubt sind ausschließlich zahlungsverkehrsfähige Konten, die für das Online-Banking freigeschaltet sind.",
      "Wenden Sie sich bei Fragen bitte an Ihre Sparkasse.",
      "Aufgetreten am: {TIMESTAMP}",
      gruß,
      signatur
    ],

    VNEO_UNBEKANNT: [
      anrede,
      "bei der Verarbeitung des Auftrags ist ein Problem aufgetreten.",
      "Bitte wenden Sie sich an Ihre Sparkasse, bevor Sie erneut bestellen. Gegebenenfalls konnte der Auftrag dennoch ausgeführt werden.",
      gruß,
      signatur
    ],

    BANK_API_FEHLER: [
      anrede,
      "beim Aufbau der Umsatzvormerkung für Ihre Bestellung ist ein Fehler aufgetreten.",
      "Bitte kontaktieren Sie Ihre Sparkasse, um zu klären, ob der Auftrag dennoch ausgeführt werden konnte oder neu erfasst werden muss.",
      gruß,
      signatur
    ],
    
    UNBEKANNT: ["Ein Fehler ist aufgetreten.", `Bitte kontaktieren Sie die BayernLB ${kontakt}, um zu klären, ob der Auftrag dennoch ausgeführt werden konnte oder neu erfasst werden muss.`],            
  },
};
